import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useWorkflowProcesses from 'api/hooks/use-workflow-processes'
import Page from 'layout/access-management/page'
import PageTitle from 'layout/page-title'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { useDebounce } from 'api/hooks/use-debounce'
import TableLoading from 'shared/tables/table-loading'
import SortablePopoverHeader from 'shared/tables/sortable-popover-header'

function WorkflowProcesses() {
  const navigate = useNavigate()
  const [search, setSearch] = useState('')
  const [filterParams, setFilterParams] = useState({
    orderBy: 'name',
    orderDirection: 'asc'
  })
  const [activePopoverId, setActivePopoverId] = useState(null)
  const debouncedSearch = useDebounce(search, 300)

  const { data, isLoading, isSuccess } = useWorkflowProcesses({
    params: { ...filterParams, search: debouncedSearch }
  })

  const crumbs = [{ name: 'Workflow Processes', url: '' }]

  return (
    <Page title="Workflow Processes">
      <PageTitle breadcrumbs={crumbs} />
      <Row className="mb-3">
        <Col sm="4">
          <InputGroup>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faSearch} />
            </InputGroup.Text>
            <FormControl
              placeholder="Search processes..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table className="bg-white shadow-sm p-1" hover>
            <thead>
              <tr>
                <SortablePopoverHeader
                  title="Process"
                  filters={filterParams}
                  setFilters={setFilterParams}
                  column="name"
                  popoverId="workflow-name-sort"
                  activePopoverId={activePopoverId}
                  setActivePopoverId={setActivePopoverId}
                />
                <SortablePopoverHeader
                  title="Approvers"
                  filters={filterParams}
                  setFilters={setFilterParams}
                  column="approvers_count"
                  popoverId="workflow-approvers-sort"
                  activePopoverId={activePopoverId}
                  setActivePopoverId={setActivePopoverId}
                />
                <SortablePopoverHeader
                  title="Approval Rules"
                  filters={filterParams}
                  setFilters={setFilterParams}
                  column="approval_rules_count"
                  popoverId="workflow-approval-rules-sort"
                  activePopoverId={activePopoverId}
                  setActivePopoverId={setActivePopoverId}
                />
                <SortablePopoverHeader
                  title="Notification Rules"
                  filters={filterParams}
                  setFilters={setFilterParams}
                  column="notification_rules_count"
                  popoverId="workflow-notification-rules-sort"
                  activePopoverId={activePopoverId}
                  setActivePopoverId={setActivePopoverId}
                />
                <SortablePopoverHeader
                  title="Pending Workflows"
                  filters={filterParams}
                  setFilters={setFilterParams}
                  column="pending_workflows_count"
                  popoverId="workflow-pending-sort"
                  activePopoverId={activePopoverId}
                  setActivePopoverId={setActivePopoverId}
                />
              </tr>
            </thead>
            <tbody>
              {isLoading && <TableLoading columns={5} />}
              {isSuccess &&
                data.map((process) => (
                  <tr
                    key={process.id}
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      navigate(`/processes/${process.id}`)
                    }
                  >
                    <td>
                      {process.name}
                      <small className="text-muted ms-2">({process.code})</small>
                    </td>
                    <td>{process.approvers_count}</td>
                    <td>{process.approval_rules_count}</td>
                    <td>{process.notification_rules_count}</td>
                    <td>{process.pending_workflows_count}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Page>
  )
}

export default WorkflowProcesses
